import validate from 'validate.js'

export const tooltips = []

function removeTooltip(elem) {
  tooltips.forEach((tooltip, index) => {
    const elemMatches = tooltip.elem === elem
    const tipExists = tooltip.tip && tooltip.tip.parentNode

    if (elemMatches && tipExists) {
      tooltip.tip.parentNode.removeChild(tooltip.tip)
      tooltips.splice(index, 1)
      return
    }
  })
}

export function removeTooltips() {
  tooltips.forEach((tooltip) => {
    if (tooltip.tip && tooltip.tip.parentNode) {
      tooltip.tip.parentNode.removeChild(tooltip.tip)
    }
  })

  return []
}

function createTooltip(elem, text) {
  removeTooltip(elem)

  const tooltip = document.createElement('div')
  const inner = document.createElement('div')
  const arrow = document.createElement('div')
  const newTooltip = {}

  tooltip.className = '_error _above'
  arrow.className = '_error-arrow'
  inner.className = '_error-inner'
  inner.innerHTML = text

  tooltip.appendChild(arrow)
  tooltip.appendChild(inner)

  newTooltip.tip = tooltip
  newTooltip.elem = elem

  tooltips.push(newTooltip)
  elem.parentNode.appendChild(tooltip)

  return newTooltip
}

export function needsValidate(el) {
  return el.name === 'email' || el.getAttribute('required') !== null
}

export function validateField(elem, remove) {
  if (remove) {
    removeTooltip(elem)
  }

  const value = {
    input: elem.value || '',
  }
  const constraints = {
    input: {},
  }

  if ('email' === elem.type || 'email' === elem.name) {
    constraints.input.email = {
      message: 'Enter a valid email address.',
    }
  } else {
    if (elem.getAttribute('required') !== null) {
      constraints.input.presence = {
        allowEmpty: false,
        message: 'Please fill out this field',
      }

      constraints.input.length = {
        minimum: 3,
        tooShort: 'Needs to have %{count} characters or more',
      }
    }
  }

  const invalid = validate(value, constraints, { fullMessages: false })

  if (invalid) {
    createTooltip(elem, invalid.input.shift())
    return false
  }

  return true
}
